export const QUIZZES_REQUEST = "QUIZZES_REQUEST";
export const QUIZZES_SUCCESS = "QUIZZES_SUCCESS";
export const QUIZZES_FAIL = "QUIZZES_FAIL";

export const QUIZZES_ANSWER_CREATE = "QUIZZES_ANSWER_CREATE";
// export const QUIZZES_ANSWER_SUCCESS = "QUIZZES_ANSWER_SUCCESS";
// export const QUIZZES_ANSWER_FAIL = "QUIZZES_ANSWER_FAIL";
